<template>
    <span class="marketing-hint" :style="{ backgroundColor: marketingHint.color }">
        <img v-if="iconSrc" :src="iconSrc" :alt="iconAlt" class="marketing-hint__icon" />
        <IconSvg v-else filepath="star.svg" />
        <span>{{ marketingHint.text }}</span>
    </span>
</template>

<script>
import marketingHintIcon from '@/mixins/marketingHintIcon';

/**
 * @typedef {Object} MarketingHint
 * @property {string} text
 * @property {number} productVariantId
 * @property {'de'|'en'|'cz'|'nl'} language
 * @property {string} [color]
 * @property {icon} [icon]
 */

export default {
    name: 'MarketingHint',

    mixins: [marketingHintIcon],

    props: {
        /**
         * @type MarketingHint
         */
        marketingHint: {
            type: [Object]
        }
    },
    computed: {
        /**
         * @returns {null|string} - webpack resolved src
         */
        iconSrc() {
            return this.getIconSrc(this.marketingHint.icon);
        },
        /**
         * @returns {null|string}
         */
        iconAlt() {
            return this.getIconAlt(this.marketingHint.icon);
        }
    }
};
</script>

<style scoped lang="scss">
.marketing-hint {
    //margin-top: 3px;
    //padding: 3px 15px 3px 10px;
    padding: 0 15px 0 10px;
    color: hsl(0, 0%, 100%);
    //border-radius: 100px;
    //font-size: 13px;
    font-weight: bold;
    //line-height: 1;
    display: inline-flex;
    align-items: center;
    white-space: normal; //sometimes hints contain long text

    .icon-svg,
    &__icon {
        margin-right: 5px;
    }

    &__icon {
        filter: invert(
            1
        ); //https://codepen.io/sosuke/pen/Pjoqqp to find proper filter value. SVG sourcecode fill change might produce artifacts
        height: 1em;
    }
}
</style>
